import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'titleCase'
})
export class TitleCasePipe implements PipeTransform {
  public transform(value: string): string {
    return _.startCase(value);
  }
}
